import React from 'react';
import styles from './Preloader.module.scss';

export const Preloader = () => (
  <div className={styles.preloader}>
    <div className={styles.spinner}></div>
  </div>
); 